import { Ether, Token } from '@sushiswap/sdk';
import { getAddress } from 'ethers/lib/utils';
export var getToken = function (swapToken, chainId) {
    switch (swapToken.address) {
        case '0x0000000000000000000000000000000000000000':
            return Ether.onChain(chainId);
        case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
            return Ether.onChain(chainId);
        case 'NATIVE':
            return Ether.onChain(chainId);
        default:
            return new Token(chainId, getAddress(swapToken.address), swapToken.decimals);
    }
};
